import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store/configureStore";

import App from "./App";
import LoadingSpinner from "./components/LoaderSpinner";
import reportWebVitals from "./reportWebVitals";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/text.css";
import "./styles/index.css";
import "./styles/style.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <LoadingSpinner />
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
